import Input from "./Input";
import React from "react";
import OTP from "./OTP";

Input.OTP = OTP;

export default Input;

export {OTP};